var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewBooksHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 6.90625C5 4.74889 6.74889 3 8.90625 3H24.5312C24.9627 3 25.3125 3.34978 25.3125 3.78125C25.3125 4.21272 24.9627 4.5625 24.5312 4.5625H8.90625C7.61184 4.5625 6.5625 5.61184 6.5625 6.90625C6.5625 8.20066 7.61184 9.25 8.90625 9.25H24.5312C24.9627 9.25 25.3125 9.59978 25.3125 10.0312V25.6562C25.3125 26.9507 24.2632 28 22.9688 28H7.34375C6.04933 28 5 26.9507 5 25.6562V6.90625ZM12.0312 18.625C12.0312 18.1935 12.381 17.8438 12.8125 17.8438H14.375V16.2812C14.375 15.8498 14.7248 15.5 15.1562 15.5C15.5877 15.5 15.9375 15.8498 15.9375 16.2812V17.8438H17.5C17.9315 17.8438 18.2812 18.1935 18.2812 18.625C18.2812 19.0565 17.9315 19.4062 17.5 19.4062H15.9375V20.9688C15.9375 21.4002 15.5877 21.75 15.1562 21.75C14.7248 21.75 14.375 21.4002 14.375 20.9688V19.4062H12.8125C12.381 19.4062 12.0312 19.0565 12.0312 18.625Z",
    fill: "#F7FAFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5938 6.125C13.1623 6.125 12.8125 6.47478 12.8125 6.90625C12.8125 7.33772 13.1623 7.6875 13.5938 7.6875H24.5312C24.9627 7.6875 25.3125 7.33772 25.3125 6.90625C25.3125 6.47478 24.9627 6.125 24.5312 6.125H13.5938Z",
    fill: "#F7FAFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewBooksHeader);
export default __webpack_public_path__ + "static/media/NewBooksHeader.75a7d6deaf9efab4b3165e2f8a0ce7c8.svg";
export { ForwardRef as ReactComponent };